<template>
  <div>
    <div class="search">
      <!-- <div class="search-input">
                <el-input v-model="searchName"  placeholder="物业项目">
                    <el-button slot="append" icon="el-icon-search" @click="searchKeyWord"></el-button>
                </el-input>
            </div> -->
    </div>
    <!-- 信息公开率详情 -->
    <el-table
      @cell-click="cellClick"
      :data="tableDataTitle"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="TempleName"
        label="公示事项名称"
        min-width="150"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Percent"
        label="公示次数"
        min-width="150"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="NumCount"
        label="催办次数"
        min-width="150"
      ></el-table-column>
    </el-table>

    <el-table
      :data="tableData"
      style="width: 100%; margin-top: 50px"
      v-loading="loading"
      element-loading-text="数据正在加载中，请稍候"
    >
      <!-- 数据加载的时候显示数据正在加载中，请稍候 -->
      <template slot="empty">
        <span v-if="loading"></span>
        <span v-else>暂无数据</span>
      </template>
      <el-table-column
        align="center"
        prop="TemplateName"
        label="公示事项名称"
        min-width="150"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="EaAreaName"
        label="物业项目"
        min-width="150"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="CreatePerson"
        label="公示人"
        min-width="150"
      ></el-table-column>
      <el-table-column align="center" label="发布时间" min-width="150">
        <template slot-scope="scope">{{
          scope.row.CreateDate | getDate
        }}</template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="150">
        <template slot-scope="scope">{{
          scope.row.IsDelete ? '已作废' : '已公示'
        }}</template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <div class="page">
        <of-page :page="page" @getData="getTableDataByType()"></of-page>
      </div>
    </div>
  </div>
</template>

<script>
import { Page } from '@/models/page';
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
import { ReprotFillQueryPara } from '@/service/PublicInfoController/ReprotFillQueryPara.js';
export default {
  name: 'informationOpenDetails',
  props: {
    eaAreaCode: String,
    columnLabel: String,
    numBool: Boolean,
    objType: Number || String,
  },
  components: {},
  data() {
    return {
      loading: false,
      searchName: '',
      tableDataTitle: [],
      tableData: [],
      page: new Page(),
      ReprotFillQueryPara: new ReprotFillQueryPara(),
      keyWord: '', // 关键词查询
      TemplateNamePara: [], // 标题数组
      year: '',
    };
  },
  filters: {
    getDate(val) {
      if (val) {
        return val.substring(0, 10);
      }
    },
  },
  created() {
    this.year = new Date().getFullYear().toString();
    this.CreditInformationController = new CreditInformationController();
    this.getTableDataTitle();
  },
  methods: {
    cellClick() {},
    // 搜索
    searchKeyWord() {},
    // 翻页
    getTableDataByType() {
      this.getTableData();
    },
    //获取列表数据eaAreaCode:String, year:String, type:int
    getTableDataTitle() {
      this.loading = true;
      this.CreditInformationController.GetPublicReportFillListByEaArea(
        this.eaAreaCode,
        this.year,
        this.objType == 1 || this.objType == 2 ? 1 : 2
      )
        .then((res) => {
          this.loading = false;
          if (res && res.infoVos) {
            this.tableDataTitle = res.infoVos;
            this.getTableData();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: error,
          });
        });
    },
    //获取列表数据para:ReprotFillQueryPara, year:String, type:int, startIndex:int, maxSize:int
    getTableData() {
      this.loading = true;
      this.tableDataTitle.forEach((item) => {
        this.TemplateNamePara.push(item.TempleName);
      });
      if (this.keyWord != '') {
        this.ReprotFillQueryPara.setParamByTemplateName(`%${this.keyWord}%`);
        this.ReprotFillQueryPara.setParamByEaAreaName(`%${this.keyWord}%`);
      }
      this.ReprotFillQueryPara.setParamByEaAreaCode(this.eaAreaCode);
      this.ReprotFillQueryPara.setParamByIsDelete(false);
      this.ReprotFillQueryPara.setParamByTemplateName_Enum(
        this.TemplateNamePara
      );
      this.CreditInformationController.GetPublicReportFillListByEaAreaDetail(
        JSON.stringify(this.ReprotFillQueryPara),
        this.year,
        this.objType - 1,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then((res) => {
          this.loading = false;
          if (res && res._Items) {
            this.tableData = res._Items;
            this.page.getCurrtNum = res.TotalCount;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: error,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  padding: 15px 0;
  display: flex;
  align-items: center;
  .search-input {
    flex: 1;
    display: flex;
    .el-input {
      .el-input__inner {
        background-color: rgb(140, 78, 127);
      }
    }
  }
}
.footer {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 10px;
  .fun {
    font-size: 14px;
    color: #409eff;
    cursor: pointer;
    .delete {
      margin-left: 20px;
    }
  }
}
</style>
